/**
 * @Author: Nemo
 * @Description: 支付选项选择器配置
 * @Date: 2024-07-10
 * @LastEditors: Nemo
 */

// 导入图片资源
import Cash_MY_7eleven from '@/assets/images/Cash_MY/1-7eleven-img.png';
import Cash_MY_99speedmart from '@/assets/images/Cash_MY/99speedmart-img.png';
import Cash_MY_kkmart from '@/assets/images/Cash_MY/kkmart-img.png';
import DANA_Bank1 from '@/assets/images/dana/bank1.png';
import DANA_Bank2 from '@/assets/images/dana/bank2.png';
import DANA_Bank3 from '@/assets/images/dana/bank3.png';
import DANA_Bank4 from '@/assets/images/dana/bank4.png';
import DANA_Bank5 from '@/assets/images/dana/bank5.png';
import DANA_Bank6 from '@/assets/images/dana/bank6.png';
import DANA_Bank7 from '@/assets/images/dana/bank7.png';
import DOKU_BCA from '@/assets/images/doku/VIRTUAL_ACCOUNT_BANK_BCA.png';
import DOKU_BNI from '@/assets/images/doku/VIRTUAL_ACCOUNT_BANK_BNI.png';
import DOKU_BRI from '@/assets/images/doku/VIRTUAL_ACCOUNT_BANK_BRI.png';
import DOKU_BSI from '@/assets/images/doku/VIRTUAL_ACCOUNT_BANK_BSI.png';
import DOKU_BTN from '@/assets/images/doku/VIRTUAL_ACCOUNT_BANK_BTN.png';
import DOKU_CIMB from '@/assets/images/doku/VIRTUAL_ACCOUNT_BANK_CIMB.png';
import DOKU_Mandiri from '@/assets/images/doku/VIRTUAL_ACCOUNT_BANK_Mandiri.svg';
import DOKU_Permata from '@/assets/images/doku/VIRTUAL_ACCOUNT_BANK_Permata.png';

// DANA银行图片

// 马来西亚现金支付图片

// 马来西亚网上银行图片
import IB_MY_Affin from '@/assets/images/Internet_Banking_MY/affin-bank-img.png';
import IB_MY_Agro from '@/assets/images/Internet_Banking_MY/agro-bank-img.png';
import IB_MY_Alliance from '@/assets/images/Internet_Banking_MY/alliance-bank-img.png';
import IB_MY_Ambank from '@/assets/images/Internet_Banking_MY/ambank-img.png';
import IB_MY_BankIslam from '@/assets/images/Internet_Banking_MY/bank-islam-img.png';
import IB_MY_BankMuamalat from '@/assets/images/Internet_Banking_MY/bank-muamalat-img.png';
import IB_MY_BankOfChina from '@/assets/images/Internet_Banking_MY/bank-of-china-img.png';
import IB_MY_BankRakyat from '@/assets/images/Internet_Banking_MY/bank-rakyat-img.png';
import IB_MY_BSN from '@/assets/images/Internet_Banking_MY/bsn-img.png';
import IB_MY_CIMB from '@/assets/images/Internet_Banking_MY/cimb-bank-img.png';
import IB_MY_HongLeong from '@/assets/images/Internet_Banking_MY/hong-leong-bank-img.png';
import IB_MY_HSBC from '@/assets/images/Internet_Banking_MY/hsbc-img.png';
import IB_MY_KuwaitFinance from '@/assets/images/Internet_Banking_MY/kuwait-finance-house-img.png';
import IB_MY_Maybank from '@/assets/images/Internet_Banking_MY/maybank-img.png';
import IB_MY_OCBC from '@/assets/images/Internet_Banking_MY/ocbc-bank-img.png';
import IB_MY_PublicBank from '@/assets/images/Internet_Banking_MY/public-bank-img.png';
import IB_MY_RHB from '@/assets/images/Internet_Banking_MY/rhb-bank-img.png';
import IB_MY_StandardChartered from '@/assets/images/Internet_Banking_MY/standard-chartered-img.png';
import IB_MY_UOB from '@/assets/images/Internet_Banking_MY/uob-img.png';

// 卡种配置
export default {
  // DOKU虚拟账户支付选项
  DOKU_VA: [
    { code: 'BCA', name: 'BCA', image: DOKU_BCA },
    { code: 'BRI', name: 'BRI', image: DOKU_BRI },
    { code: 'BNI', name: 'BNI', image: DOKU_BNI },
    { code: 'BSI', name: 'BSI', image: DOKU_BSI },
    { code: 'BTN', name: 'BTN', image: DOKU_BTN },
    { code: 'CIMB', name: 'CIMB', image: DOKU_CIMB },
    { code: 'Mandiri', name: 'Mandiri', image: DOKU_Mandiri },
    { code: 'Permata', name: 'Permata', image: DOKU_Permata },
  ],

  // DANA银行支付选项
  DANA_VA: [
    { code: 'bank1', name: 'Bank 1', image: DANA_Bank1 },
    { code: 'bank2', name: 'Bank 2', image: DANA_Bank2 },
    { code: 'bank3', name: 'Bank 3', image: DANA_Bank3 },
    { code: 'bank4', name: 'Bank 4', image: DANA_Bank4 },
    { code: 'bank5', name: 'Bank 5', image: DANA_Bank5 },
    { code: 'bank6', name: 'Bank 6', image: DANA_Bank6 },
    { code: 'bank7', name: 'Bank 7', image: DANA_Bank7 },
  ],

  // 马来西亚现金支付选项
  Cash_MY: [
    { code: '7eleven', name: '7-Eleven', image: Cash_MY_7eleven },
    { code: '99speedmart', name: '99 Speedmart', image: Cash_MY_99speedmart },
    { code: 'kkmart', name: 'KK Mart', image: Cash_MY_kkmart },
  ],

  // 马来西亚网上银行支付选项
  Internet_Banking_MY: [
    { code: 'affin', name: 'Affin Bank', image: IB_MY_Affin },
    { code: 'agro', name: 'Agro Bank', image: IB_MY_Agro },
    { code: 'alliance', name: 'Alliance Bank', image: IB_MY_Alliance },
    { code: 'ambank', name: 'AmBank', image: IB_MY_Ambank },
    { code: 'bankislam', name: 'Bank Islam', image: IB_MY_BankIslam },
    { code: 'bankmuamalat', name: 'Bank Muamalat', image: IB_MY_BankMuamalat },
    { code: 'bankofchina', name: 'Bank of China', image: IB_MY_BankOfChina },
    { code: 'bankrakyat', name: 'Bank Rakyat', image: IB_MY_BankRakyat },
    { code: 'bsn', name: 'BSN', image: IB_MY_BSN },
    { code: 'cimb', name: 'CIMB Bank', image: IB_MY_CIMB },
    { code: 'hsbc', name: 'HSBC', image: IB_MY_HSBC },
    { code: 'hongleong', name: 'Hong Leong Bank', image: IB_MY_HongLeong },
    { code: 'kuwaitfinance', name: 'Kuwait Finance House', image: IB_MY_KuwaitFinance },
    { code: 'maybank', name: 'Maybank', image: IB_MY_Maybank },
    { code: 'ocbc', name: 'OCBC Bank', image: IB_MY_OCBC },
    { code: 'publicbank', name: 'Public Bank', image: IB_MY_PublicBank },
    { code: 'rhb', name: 'RHB Bank', image: IB_MY_RHB },
    { code: 'standardchartered', name: 'Standard Chartered', image: IB_MY_StandardChartered },
    { code: 'uob', name: 'UOB', image: IB_MY_UOB },
  ],
};
